import { Box, SxProps, Theme, Typography } from '@mui/material';
import { useCallback } from 'react';
import { UseTableCellProps } from 'react-table';
import { formatDateTime } from 'shared/utility';

const gridStyles: SxProps<Theme> = {
  display: 'grid',
};

export function QuoteFormatDateColumn(props: UseTableCellProps<any>) {
  const { value } = props;

  const getDate = useCallback(() => {
    try {
      return formatDateTime(new Date(value));
    } catch (e) {
      console.log('Unable to format date: ', value);
    }

    return value;
  }, [value]);

  return (
    <Box sx={gridStyles}>
      <Typography variant='body2'>{getDate()}</Typography>
    </Box>
  );
}
